import { ReviewCanvasContext } from 'modules/match-video/domain/interfaces';

export interface MaskBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Draws content that rises into `box` from under its bottom edge, the «text comes up from under a line» reveal:
 * at `progress` 0 it is `distance` below its place and clipped away, at 1 it sits in place. `draw` paints the content
 * at its final position; the shift and the clip are applied around it.
 *
 * `distance` defaults to the box height; the mockup's `riseIn` moves 115 % of the text's own line instead.
 */
export function drawRisingFromLine(
  ctx: ReviewCanvasContext,
  box: MaskBox,
  progress: number,
  draw: (ctx: ReviewCanvasContext) => void,
  distance: number = box.height,
): void {
  const k = Math.min(1, Math.max(0, progress));
  if (k <= 0) return;
  ctx.save();
  ctx.beginPath();
  ctx.rect(box.x, box.y, box.width, box.height);
  ctx.clip();
  ctx.translate(0, (1 - k) * distance);
  draw(ctx);
  ctx.restore();
}
